import { decode } from 'html-entities';
import React from 'react';
import * as Icon from 'react-feather';
import {useSelector} from 'react-redux';
import {useAppDispatch} from '../../hooks/redux';

import { closeViewBookmark } from '../../slices/bookmarkModalSlice';
import i18n from "../../i18n";
import { RootState } from '../../types';

export default function() {
    // load user detail here
    const dispatch = useAppDispatch()
    // const currentUser = useSelector((state: RootState) => state.user);
    const isVisible = useSelector((state: RootState) => state.bookmarkModal.viewBookmark.visible)
    const modelData = useSelector((state: RootState) => state.bookmarkModal.viewBookmark.model)

    const onCancel = () => {
        dispatch(closeViewBookmark());
    }

    const showHideClassName = isVisible ? "bookmark-modal display-block" : "bookmark-modal display-none"
    return (
        isVisible &&
        <div className={showHideClassName}>
            <div className="bookmark-modal-main">
                <div className='bookmark-modal-header'>
                    <div>{i18n.t('modal:bookmark-detail')}</div>
                    <div style={{height: "24px"}} onClick={onCancel}><Icon.X size="24" /></div>
                </div>
                <div className='bookmark-view-modal-body'>
                    <div className='body-item'>
                        <div className='label-url'>{i18n.t('modal:URL')}</div>
                        <div className='external-link'><a href={decode(modelData.url)} target="_blank" rel="noreferrer">{modelData.url.slice(0, 90)}</a><Icon.ExternalLink size="16" /></div>
                    </div>
                    <div className='body-item'>
                        <div className='label'>{i18n.t('universal:title')}</div>
                        <div className='text'>{modelData.title}</div>
                    </div>
                    <div className='body-item'>
                        <div className='label'>{i18n.t('universal:description')}</div>
                        <div className='description'>{modelData.description}</div>
                    </div>
                    <div className='body-item'>
                        <div className='label'>{i18n.t('modal:creator')}</div>
                        <div className='text'>{modelData.creator}</div>
                    </div>
                    <div className='body-item'>
                        <div className='label'>{i18n.t('modal:created-at')}</div>
                        <div className='text'>{modelData.create_time}</div>
                    </div>
                    <div className='body-item'>
                        <div className='label'>UUID</div>
                        <div className='text'>{modelData.entity}</div>
                    </div>
                </div>
            </div>
        </div>
    )
}
